import repeatController from './repeaterController'
import template from './index.html'

const formly = {
  key: 'Parts',
  name: 'Parts',
  controller: repeatController,
  templateUrl: template,
  templateOptions: {
    addText: 'Add Parts',
    fields: [
      {
        key: 'PartNumber',
        type: 'gridReadonly',
        className: 'col-xs-2'
      },
      {
        key: 'PartDescription',
        type: 'gridReadonly',
        className: 'col-xs-6'
      },
      {
        key: 'Quantity',
        name: 'Quantity',
        type: 'gridInput',
        templateOptions: {
          min: 0,
          type: 'number',
          required: true
        },
        className: 'col-xs-2'
      }
    ]


  }
}

export default formly